var lib_core = require("lib-core");
var NetData = require("./netData.js");

var LogicTerminalInstance = function () {
    lib_core.AbstractInstance.call(this);
};
lib_core.inherit(LogicTerminalInstance, lib_core.AbstractInstance);
LogicTerminalInstance.$class = "LogicTerminalInstance";

module.exports = LogicTerminalInstance;

LogicTerminalInstance.prototype.net = function() {
    if (this.parent()) {
        if (this.parent().parent()) {
            return this.parent().parent().logicTerminalNetMap.get(this);
        }
    }
    return null;
};
